import {useMemo} from 'react'

export const useAggregatedServices =selectedServices => useMemo(()=>getAggregatedServices(selectedServices),[selectedServices])

  export const useDecryptServicesHash = (servicesHash) => useMemo(()=>servicesHash.split('#'),[servicesHash])

  export const getAggregatedServices =selectedServices => selectedServices?.reduce((acc,activity,index,arr)=>{
    acc.price += +activity?.price
    acc.duration += +activity?.duration
    acc.subProfessionId.heName += (activity?.name || activity?.subProfessionId?.heName || activity?.heName) + (index !== arr.length - 1 ? ', ' : '')
    acc.heName += (activity?.name || activity?.subProfessionId?.heName || activity?.heName) + (index !== arr.length - 1 ? ', ' : '')
    acc.subProfessionName += (activity?.name || activity?.subProfessionId?.heName || activity?.heName) + (index !== arr.length - 1 ? ', ' : '')
    acc.activityId += activity.activityId + (index !== arr.length - 1 ? '#' : '')
    
    return acc
  },{price:0,duration:0,heName:'',subProfessionId:{heName:''},subProfessionName:'',activityId:''})